import EvaluationStudents from '@/models/EvaluationStudents';

const GET_EVALUATION_STUDENTS = 'get_evaluationStudents';
const GET_EVALUATION_STUDENTS_REQUEST = 'get_evaluationStudents_request';
const GET_EVALUATION_STUDENTS_SUCCESS = 'get_evaluationStudents_success';
const GET_EVALUATION_STUDENTS_ERROR = 'get_evaluationStudents_error';

export { GET_EVALUATION_STUDENTS };

export default {
    state: {
        evaluationStudents: [],
        loading: false,
        evaluationStudentsErrors: [],
        evaluationStudentsMeta: {},
    },
    mutations: {
        [GET_EVALUATION_STUDENTS_REQUEST]: (state) => {
            state.evaluationStudents = [];
            state.loading = true;
            state.evaluationStudentsErrors = [];
        },
        [GET_EVALUATION_STUDENTS_SUCCESS]: (state, { evaluationStudents, meta }) => {
            state.evaluationStudents = evaluationStudents;
            state.loading = false;
            state.evaluationStudentsErrors = [];
            state.evaluationStudentsMeta = meta;
        },
        [GET_EVALUATION_STUDENTS_ERROR]: (state, { errors }) => {
            state.evaluationStudents = [];
            state.loading = false;
            state.evaluationStudentsErrors = errors;
            state.evaluationStudentsMeta = {};
        },
    },
    actions: {
        [GET_EVALUATION_STUDENTS]: ({ commit, state }, { params = {} }) => {
            commit(GET_EVALUATION_STUDENTS_REQUEST);
            return new Promise((resolve, reject) => {
                // If no page specified at dispatch
                if (!params.page) {
                    // Use the current one if present, the first one othewise
                    if (state.evaluationStudentsMeta.current_page) {
                        params.page = state.evaluationStudentsMeta.current_page;
                    } else {
                        params.page = 1;
                    }
                }

                EvaluationStudents.collection(params)
                    .then(({items, meta}) => {
                        const evaluationStudents = items;
                        commit(GET_EVALUATION_STUDENTS_SUCCESS, { evaluationStudents, meta });
                        resolve(items);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_EVALUATION_STUDENTS_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/evaluation-students.js